import React from 'react';
import Button from '../Button';
import Vaccines from '../../assets/images/vaccines.png';
import { QuantityButton } from '../../utils';
import { Delete } from '../../HemeIconLibrary';

const Index = ({ data, changeQuantity, addToCart, setFilterData }) => {
  return (
    <div className="w-full sm:w-[304px] min-h-[359px] rounded-[35px] overflow-hidden relative">
      <div className="w-full h-[200px] bg-cover bg-top bg-no-repeat " style={{ backgroundImage: `url(${Vaccines})` }} />
      <div className=" absolute top-[76px] left-0 w-full h-full rounded-[35px] bg-white shadow-md2Shadow pt-[22px] px-6 pb-[21px]">
        <div className="w-full min-h-[240px] flex flex-col justify-between">
          <div className="w-full ">
            <h5 className="text-base leading-[19px]  font-bold text-primary1 mb-[10px]">{data?.name}</h5>
            <p className="font-normal text-base mb-[34px] text-[#796CA7]">{data?.description}</p>
          </div>
          <div className=" flex items-center gap-[10px] justify-between">
            <QuantityButton changeQuantity={changeQuantity} data={data} />

            <Button
              text="Add to Cart"
              color="text-primary2"
              bg="bg-white"
              border="border-primary1 "
              className="px-[20px] py-[12px] rounded-lg"
              cta={() => {
                addToCart(data, true);
              }}
            />

            {/* {data?.addtocart ? (
              <Button
                color="text-primary2"
                bg="bg-white"
                Icon={<Delete color="#605DAF" />}
                border="border-[#605DAF] "
                className="rounded-lg "
                cta={() => {
                  addToCart(data, false);
                }}
              />
            ) : (
              <Button
                text="Add to Cart"
                color="text-primary2"
                bg="bg-white"
                border="border-primary1 "
                className="px-4 rounded-lg"
                cta={() => {
                  addToCart(data, true);
                }}
              />
            )} */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
